import type { ReactNode } from 'react';
import LiveBlockText from './LiveBlockText';

export type FooterProps = {
  left?: ReactNode;
  right?: ReactNode;
};

export default function Footer({ left, right }: FooterProps) {
  return (
    <footer>
      <span>{left ?? 'METHA · v2 mockup'}</span>
      <span>
        {right ?? (
          <>
            SEPOLIA · BLOCK #<LiveBlockText />
          </>
        )}
      </span>
    </footer>
  );
}
